import { iterator as Symbol_iterator } from '../symbol/iterator';
import { isFunction } from './isFunction';
export function isIterable(input) {
    return isFunction(input === null || input === void 0 ? void 0 : input[Symbol_iterator]);
}
//# sourceMappingURL=isIterable.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/dist/esm5/internal/util/isIterable.js
// module id = 427
// module chunks = 0